import { Injectable, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

declare var swal:any;
declare var wdtEmojiBundle: any;

@Injectable({
  providedIn: 'root'
})
export class ApiRestService {
  api: string = "https://affiliatesapi.virtualsoft.tech";
  apiConfig: string = "https://affiliatesapi.virtualsoft.tech";
  auth_token: string = "";
  auth_token2: string = "";
  loading: any;
  isLoading = false;
  urlApi={
    isWsConnection: false,
    url: '',
    ws: ''
  };
  partner:any;

  constructor(
  	private http: HttpClient,
  	) {

   }

  setPartner(partner: any) {
      this.partner = partner;
      /*console.log(this.partner);*/
  }

  requestCustom(path: any, request: any) {
    if(window.localStorage.getItem("auth_token")!=undefined){
      this.auth_token2=window.localStorage.getItem("auth_token");
    }else{
      this.auth_token2="";
    }
    const headers = new HttpHeaders().set("swarm-session", this.auth_token2);
    return this.http.post(path, request, {headers}).pipe(
        map((response1: any) => {
          return response1;
        }),
        catchError((err: HttpErrorResponse) => {
          /*this.notifier.show({
              message: wdtEmojiBundle.render('No se ha establecido conexión con el servidor.'),
              type: 'error',
              template: this.customNotificationTmpl,
          });*/
          return throwError(err);
        })
    )

  }

  request(command: any, param: any, requestOptions: any) {
    if (requestOptions === void 0) {
                    requestOptions = {};
                }
    param.partner = this.partner;
    /*this.present();*/

    if(this.urlApi.isWsConnection){

    }else{
      const path = `${this.api+"/"+command}`;
      const request = param;

      return this.http.post(path, request, requestOptions).pipe(




      )
    }
  }
}
